import React,{Component} from 'react';
import {  
  Popover,
  PopoverBody 
} from 'reactstrap';

import InformationSVG from '../../assets/information.svg';

import { generateGUID  } from '../../utils';

class InfoToolTip extends Component {
  constructor(){
    super();

    this.state ={
      tooltipOpen:false,
      randomId:generateGUID()
    }
  }

  componentDidMount(){
    //IN THE FUTURE THIS WILL LISTEN TO A TOOLTIP PROVIDER FROM THE CONTEXT
  }

  render(){
    const { tooltipOpen, randomId } = this.state;
    const { text } = this.props;

    return (
      <span>
        &nbsp;&nbsp;
        <img
          alt='Aspect ratio information'
          src={InformationSVG}
          id={`tooltip_${randomId}`}
          onMouseEnter={() => this.setState({tooltipOpen:true})}
          onMouseLeave={() => this.setState({tooltipOpen:false})}
        />
        <Popover
          className='TooltipPopover'
          isOpen={tooltipOpen}
          target={`tooltip_${randomId}`}
          placement='right'
        >
          <PopoverBody>{text}</PopoverBody>
        </Popover>
      </span>
    )
  }
}

export default InfoToolTip;



// WEBPACK FOOTER //
// ./src/shared/components/InfoTooltip/index.js